import React, { useEffect, useRef, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';

import TopBackBtn from '../../components/top_back_btn/top_back_btn';

import { faqList } from '../../data/faq';

import styles from './support_faq.module.css';

const SupportFaq = () => {
  const location = useLocation();
  const { pathname } = location;

  const searchRef = useRef(null);
  const [list, setList] = useState(faqList);
  const [search, setSearch] = useState(null);

  const topFaqList = faqList.filter((faq) => [1, 5, 9, 11].includes(faq.faqId));

  const clearSearchValue = () => {
    setList(faqList);
    setSearch(null);
    sessionStorage.clear();
  };

  let timeout;
  const onChangeSearch = (e) => {
    e.preventDefault();

    clearTimeout(timeout);
    timeout = setTimeout(() => {
      let value = e.target.value;
      if (!value) {
        clearSearchValue();
        return;
      }

      setSearch(e.target.value);
    }, 300);
  };

  const onSearch = (text) => {
    sessionStorage.setItem('faq_search', text);
    text
      ? setList(
          faqList.filter(
            (faq) => faq.question.includes(text) || faq.answer.includes(text)
          )
        )
      : setList(faqList);
  };

  const onSearchClear = (e) => {
    e.preventDefault();
    setSearch(null);
    searchRef.current.value = '';
  };

  useEffect(() => {
    search && onSearch(search);
  }, [search]);

  useEffect(() => {
    window.scrollTo(0, 0);

    let searchValue = sessionStorage.getItem('faq_search');
    if (searchValue) {
      setSearch(searchValue);
      searchRef.current.value = searchValue;
    }
  }, []);

  return (
    <>
      <div className={styles.container}>
        <div className={styles.search}>
          <input
            className={styles.input}
            type='text'
            ref={searchRef}
            placeholder='예) 메뉴, 포스, 결제'
            onChange={onChangeSearch}
          />
        </div>

        {search ? (
          <TopBackBtn text='처음으로' onClick={onSearchClear} />
        ) : (
          <div className={styles.topFaqContainer}>
            <h2 className={styles.sectionTitle}>자주 하는 질문 TOP</h2>

            <div className={styles.topFaqBox}>
              {topFaqList.map((faq) => {
                return (
                  <Link
                    key={faq.faqId}
                    to={faq.faqId.toString()}
                    state={{ from: pathname, faqId: faq.faqId }}
                  >
                    <div className={styles.faqCard}>
                      <span>Q</span>
                      <div>{faq.question}</div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        )}

        <div className={styles.faqContainer}>
          <h2 className={styles.sectionTitle}>
            {search ? '검색 결과' : '전체 질문'}
          </h2>
          <ul className={styles.questions}>
            {list && list.length !== 0
              ? list.map((faq) => {
                  let { faqId, question } = faq;
                  return (
                    <li key={faqId} className={styles.question}>
                      <Link
                        to={faqId.toString()}
                        state={{ faqId, from: pathname }}
                      >
                        <span>Q</span>
                        <span>{question}</span>
                      </Link>
                    </li>
                  );
                })
              : '해당 내용이 없습니다'}
          </ul>
        </div>
      </div>
    </>
  );
};

export default SupportFaq;
